import React from 'react';  // import the React library
import '../App.css'; // import your CSS file
import { motion } from 'framer-motion';
import BioLine from '../articleComponents/bioLine.js'; // import your CSS file
import Connect from '../articleComponents/connect';
import SocialMedia from '../articleComponents/SocialMedia';
import MetaTags from '../mainPageComponents/MetaTags';
import Thirties from "../images/thirties-scene.jpg";
import Image from '../mainPageComponents/image.js';
import TraversePosts from '../articleComponents/navigation';

const today = new Date("2, 1, 2021").toLocaleDateString('en-US', {  
  day:   'numeric',
  month: 'short',
  year:  'numeric',
  weekday: 'long'
});

function AlCaponeAmazon() {

  return (
        <motion.div className="articleStyle"
        initial={{ opacity: 0 }}
animate={{opacity: 1 }}
exit={{ opacity: 0}}
transition={{duration: .4}}
>

<MetaTags title="Parler, Amazon, and Al Capone" desc="Al Capone's booze racket seemed unstoppable in the 1930s. Who would have thought they nailed him with tax evasion? Amazon might be taken down in the same unexpected manner." 
URL="https://highway-60.firebaseapp.com/articles/amazon-and-al-capone" imageURL={Thirties} />

        <h1 id="top" style={{marginTop: '2em'}}>Amazon and Al Capone</h1>

<Image picURL={Thirties} />

<BioLine />
<p>{today}</p>

<div style={{textAlign: "left", marginTop: "5px", marginBottom: "20px"}}>
<SocialMedia url="https://highway-60.firebaseapp.com/articles/amazon-and-al-capone" title="Parler, Amazon, and Al Capone" hashtag="#highway60" hashtagArray={["amazon", "freespeech"]} 
via="TheHighway60" desc="Al Capone's booze racket seemed unstoppable in the 1930s. Who would have thought they nailed him with tax evasion? Amazon might be taken down in the same unexpected manner." />
</div>

<p>
Israel National News just published my article about a simple way to keep Big Tech from becoming Big Brother. 
</p>

<p>
It's a lot of fun if you like Amazon, politics, stocks, DevOps, and dystopia. 
</p>

<p>
Enjoy. You can view it <a href="https://www.israelnationalnews.com/News/News.aspx/295932" target="_blank">right here</a>.
</p>

<TraversePosts prevURL="/articles/by-any-other-name" nextURL="../articles"/>

<Connect />
</motion.div>
  );
}

export default AlCaponeAmazon;
